import { Box } from "@mui/material";
import HeadingSubHeading from "../../common/HeadingSubHeading/HeadingSubHeading";
import ImageAndText from "../ImageAndText/ImageAndText";
import phoneIcon from "../../assets/svgs/phone-icon.svg";
import mailIcon from "../../assets/svgs/mail-icon.svg";
import clockIcon from "../../assets/svgs/clock-icon-1.svg";
import { CustomerDetailsCardStyles } from "./CustomerDetailsCardStyles";
import { Policies } from "../CustomerDetailsList/CustomerDetailsList";

const icons: { [key: string]: string } = {
  phoneIcon,
  mailIcon,
  clockIcon,
};

interface CustomerDetailsCardProps {
  data: Policies;
}

const CustomerDetailsCard: React.FC<CustomerDetailsCardProps> = ({ data }) => {
  const {
    activePolicies,
    cancelledPolicies,
    renewalInprogressPolicies,
    totalPolicies,
  } = data;
  const policyMetrics = [
    { key: "Total", data: totalPolicies },
    { key: "Active", data: activePolicies },
    {
      key: "Cancelled",
      data: cancelledPolicies,
    },
    {
      key: "Renewal In Progress",
      data: renewalInprogressPolicies,
    },
  ];

  const getHeaderData = (policyMetrics: any) => {
    return policyMetrics.map(({ key, data }: { key: string; data: any }) => ({
      heading: data ? data?.count : "-",
      subHeading: key,
    }));
  };

  return (
    <Box 
      id="customer-details-card-container"
      data-test-id="test-customer-details-card-container"
      aria-label="Customer details card"
      sx={CustomerDetailsCardStyles.container}
    >
      <Box 
        id="customer-details-policy-details"
        data-test-id="test-customer-details-policy-details"
        aria-label="Policy details section"
        sx={CustomerDetailsCardStyles.policyDetails}
      >
        <Box 
          id="customer-details-policy-container"
          data-test-id="test-customer-details-policy-container"
          aria-label="Policy metrics container"
          sx={CustomerDetailsCardStyles.policyContainer}
        >
          {getHeaderData(policyMetrics).map((item: any, index: number) => (
            <HeadingSubHeading
              key={index}
              heading={item.heading}
              subheading={item.subHeading}
              containerAdditionalClassName={
                CustomerDetailsCardStyles.contentContainer
              }
              headingAdditionalClassName={
                CustomerDetailsCardStyles.contentContainerHeading
              }
              subHeadingAdditionalClassName={
                CustomerDetailsCardStyles.contentContainerSubHeading
              }
              customerCard={true}
            />
          ))}
        </Box>
      </Box>
      {/* <Box>
        <ImageAndText
          image={clockIcon}
          additionalClassName={
            CustomerDetailsCardStyles.interactionDetailContainer
          }
          text={`Last Interaction`}
          additionalClassText={CustomerDetailsCardStyles.interactionDetail}
        />
      </Box> */}
    </Box>
  );
};

export default CustomerDetailsCard;
